import Vue from "vue";
import VueRouter from "vue-router";
import DefaultLayout from "@/layout/TopNav.vue";
import store from "@/store";
import frontDynamicRouter from "./frontDynamicRouter";

Vue.use(VueRouter);

// 静态路由（登录页等必须路由）
const staticRoutes = [
  // {
  //   path: "/home",
  //   name: "home",
  //   component: () => import("@/views/home/index.vue"),
  //   meta: { hidden: true },
  //   children: [
  //     {
  //       path: "index",
  //       name: "首页",
  //       component: () => import("@/views/home/index/index.vue"),
  //       meta: { hidden: true },
  //     },
  //     {
  //       path: "course",
  //       name: "课程",
  //       component: () => import("@/views/home/course/index.vue"),
  //       meta: { hidden: true },
  //     },
  //     {
  //       path: "simulation",
  //       name: "虚拟仿真",
  //       component: () => import("@/views/home/simulation/index.vue"),
  //       meta: { hidden: true },
  //     },
  //   ],
  // },
  {
    path: "/",
    component: DefaultLayout,
    redirect: "index",
    children: [
      {
        path: "index",
        fullPath: "/index",
        name: "首页",
        component: () => import("@/views/index"),
      },
      {
        path: "personalinformation",
        fullPath: "/personalinformation",
        name: "个人中心",
        component: () => import("@/views/personalinformation/index.vue"),
        meta: { hidden: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: { hidden: true },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register.vue"),
  },
  {
    path: "/course/knowledgegraph-standalone",
    name: "知识图谱-独立页面",
    component: () => import("@/views/course/detail/knowledgegraph/index.vue"),
    meta: { hidden: true, noLayout: true },
  },
  {
    path: "/chat",
    name: "AI 对话",
    component: () => import("@/views/aiChat/index.vue"),
    meta: { hidden: true, noLayout: true },
  },
];

// 404必须是在最后一个路由
const notFound404Route = [
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];

// 创建路由实例（先使用静态路由）
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: staticRoutes,
});

// 动态路由加载
export async function generateRoutes(routeList) {
  console.log(routeList);

  // 存放最终要添加的路由数组
  const dynamicRoutes = [];

  /**
   * 根据组件路径解析组件
   * @param {string} componentPath - 组件相对路径（如：'personalcenter/index.vue'）
   * @returns {Function} 动态导入函数
   */
  function resolveComponent(componentPath) {
    return () => import(`@/views/${componentPath}`);
  }

  /**
   * 递归格式化后端路由为 Vue Router 路由对象
   * @param {Object} route - 当前路由对象
   * @param {string} parentPath - 父级路径
   */
  function formatRoute(route, parentPath = "") {
    const fullPath = `${parentPath}/${route.path}`.replace(/\/{2,}/g, "/");
    const vueRoute = {
      path: route.path,
      fullPath,
      redirect: route.redirect,
      name: route.name,
      meta: route.meta || {},
      component: resolveComponent(route.component || route.path),
      children: [],
    };

    if (route.children && route.children.length > 0) {
      route.children.forEach((child) => {
        vueRoute.children.push(formatRoute(child, fullPath));
      });
    }

    return vueRoute;
  }

  /**
   * 将后端路由列表转换为 Vue Router 路1由1数1组1
   */
  routeList.forEach((route) => {
    dynamicRoutes.push(formatRoute(route));
  });

  // 添加动态路由到 `/` 的 children 中
  const rootRoute = router.options.routes.find((r) => r.path === "/");
  rootRoute.children.push(...dynamicRoutes);

  // 添加自定义动态路由到 `/` 的 children 中
  // rootRoute.children.push(...frontDynamicRouter);

  /**
   * 根据父级路径查找父级路由
   * @param route
   * @param parentPath
   * @returns {null|*}
   */
  function findParentRoute(route, parentPath) {
    if (route.path === parentPath) {
      return route;
    }
    if (route.children && route.children.length > 0) {
      for (let i = 0; i < route.children.length; i++) {
        const childRoute = route.children[i];
        if (childRoute.path === parentPath) {
          return childRoute;
        }
      }
    } else {
      return null;
    }
  }

  // 判断是否有权限，添加动态路由到 `/` 的 children 中
  frontDynamicRouter.forEach((element) => {
    if (element.parentPath === "/") {
      rootRoute.children.push(element);
      return;
    }
    const children = rootRoute.children;
    for (let i = 0; i < children.length; i++) {
      // 找到父级路由
      const route = findParentRoute(children[i], element.parentPath);
      if (route) {
        if (!route.children) {
          route.children = [];
        }
        route.children.push(element);
        break;
      }
    }
  });

  function filterHiddenRoutes(routes) {
    // 先深拷贝整个数组，避免修改原数据
    const routesCopy = JSON.parse(JSON.stringify(routes));
    return routesCopy.reduce((acc, route) => {
      // 先递归处理 children
      if (route.children && route.children.length > 0) {
        route.children = filterHiddenRoutes(route.children);
      }

      // 如果当前路由没有被隐藏，则保留
      if (!(route.meta && route.meta.hidden === true)) {
        acc.push(route);
      }
      return acc;
    }, []);
  }
  // 过滤掉 hidden 为 true 的路由
  const vuexRoutes = filterHiddenRoutes(rootRoute.children);

  // 更新 Vuex：过滤掉 hidden 为 true 的路由
  // const vuexRoutes = [...rootRoute.children].filter(
  //   (route) => !route.meta?.hidden
  // );

  store.commit("route/SET_ROUTES", vuexRoutes);

  // 重新设置路由
  router.addRoutes([rootRoute]);
  router.addRoutes(notFound404Route);

  console.log("router", router);
  // console.log("vuexRoutes路由", vuexRoutes);
  // console.log("动态添加的路由:", dynamicRoutes);
}

// 防止连续点击多次路由报错
const routerPush = VueRouter.prototype.push;
const routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default router;
